export default "__VITE_ASSET__BBF3jEPc__"